import React from "react";

export default function Copyright() {
  const currentYear = new Date().getFullYear();

  return (
    <div id="copyright" className="copyright-bar" style={{ background: "#f2ede2", borderTop: "1px solid #e3dbc9" }}>
      <div className="container">
        <div className="row align-items-center g-2">
          <div className="col-md-7 text-center text-md-start">
            <span style={{ fontSize: "0.85rem", color: "#6c7d91" }}>
              <i className="fas fa-cross text-secondary me-2"></i>
              &copy; 1841 &ndash; {currentYear} <strong>St. Mary's Cathedral, Madurai</strong>. Roman Catholic Archdiocese of Madurai. All rights reserved.
            </span>
          </div>
          <div className="col-md-5 text-center text-md-end">
            <span style={{ fontSize: "0.85rem", color: "#6c7d91" }}>
              Digital Presence by{" "}
              <a
                href="https://idntica.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "var(--cathedral-navy)", fontWeight: 600, textDecoration: "underline" }}
              >
                Idntica
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
